// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"341":"2aa51cb8","828":"38baa604"}[chunkId] + ".js";
};